<template>
  <div class="pagination">
    <vue-awesome-paginate
      :total-items="totalItems"
      :page-size="pageSize"
      :items-per-page="itemsPerPage"
      :max-pages-shown="maxPagesShown"
      v-model="currentPage"
      :on-click="onPageClick"
      prev-button-content="←"
      next-button-content="→"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      default: 10
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    maxPagesShown: {
      type: Number,
      default: 10
    },
    onPageChanged: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const currentPage = ref(1);
    const headerHeight = ref(0);

    const onPageClick = (page) => {
      currentPage.value = page;
      props.onPageChanged(page);
      scrollToTop();
    };

    const scrollToTop = () => {
      const contryInfo = document.querySelector(".filters");
      if (contryInfo) {
        const contryInfoOffset = contryInfo.offsetTop;
        const scrollToPosition = contryInfoOffset - headerHeight.value;
        window.scrollTo({
          top: scrollToPosition,
          behavior: "smooth"
        });
      }
    };

    onMounted(() => {
      const header = document.querySelector("header");
      if (header) {
        headerHeight.value = header.offsetHeight;
      }
    });

    return {
      currentPage,
      onPageClick,
    };
  },
};
</script>